export enum ShareType {
	TRANSACTION = "transaction",
	ASSET_DETAIL = "asset_detail"
}
